export default function fieldShouldRender(field, record) {
  const renderIf = field.renderIf || (() => true);
  return renderIf(record);
}



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/dynamic_forms/fieldShouldRender.js